<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >
    <b-card-header>
      <div>
        <b-card-title> Quotations</b-card-title>
      </div>

      <b-dropdown
          variant="link"
          no-caret
          class="chart-dropdown"
          toggle-class="p-0"
      >
        <template #button-content>
          <feather-icon
              icon="FilterIcon"
              size="18"
              class="text-body cursor-pointer"
          />
        </template>

        <b-dropdown-item href="#" v-b-modal.filter-by-date-outlet-performance-redemption>

          Filter By Date
        </b-dropdown-item>

      </b-dropdown>
    </b-card-header>
    <b-card-body>
      <b-row class="mx-0">
        <b-col
            md="12"
            class="revenue-report-wrapper"
        >

          <table class="table table-bordered">
            <tr>
              <th>
                  Pending
              </th>
              <th>{{ quotationStats.pending | currency("KES ", 0)  }}</th>
            </tr>
            <tr>
              <th>
                Confirmed
              </th>
              <th>{{ quotationStats.confirmed | currency("KES ", 0)  }}</th>
            </tr>
          </table>

        </b-col>
      </b-row>
    </b-card-body>

    <b-modal id="filter-by-date-outlet-performance-redemption" title="Filter By Date" @cancel="true" @ok="getOutletPerformanceData"   centered>

      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-6">
              <div class="form-group ">
                <label class="control-label ">Start Date:</label> <br/>
                <div >
                  <date-picker  :lang="lang" v-model="startDate" valueType="format" :first-day-of-week="1"></date-picker>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group ">
                <label class="control-label ">End Date:</label> <br/>
                <div >
                  <date-picker  :lang="lang" v-model="endDate" valueType="format" :first-day-of-week="1"></date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import {mapActions} from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
    DatePicker
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns:['outletName','totalPoints'],
      startDate:'2020-01-01',
      endDate:new Date().toISOString().split('T')[0],
      quotationStats:{
        pending:0,
        confirmed:0
      }
    }
  },
  mounted (){
    this.getQuotationStatsData();
  },
  methods: {
    ...mapActions(["getQuotationStats"]),

    getQuotationStatsData(){
      let self = this;
      this.getQuotationStats({startDate: this.startDate, endDate: this.endDate})
          .then(function (quotationStats) {

            self.quotationStats = quotationStats;

          })
          .catch(function (error) {


          })
    },

    getOutletPerformanceData(){
      let self = this;

      this.isLoading = true;

      this.getOutletPerformance({startDate: this.startDate, endDate:this.endDate,transactionType:this.transactionType})
          .then(function (outlets) {
            outlets.length = 10
            self.isLoading = false;
            self.outlets = outlets;

          })
          .catch(function (error) {

            self.isLoading = false;

            console.log(error)
          })
    },
  }
  }
</script>
